import { DashboardGetCardResponseEntity, DashboardGetMapResponseEntity, DashboardGetResponseEntity } from "../entities/DashboardEntity";
import ApiService from "./ApiService";

export default class DashboardService extends ApiService {
	public async get(questionnaireId: number, clientId: number, unitId: number) {
		return await this.request.get<DashboardGetResponseEntity>(`/api/v1/Dashboard`, { params: { QuestionnaireId: questionnaireId, ClientId: clientId, UnitId: unitId } });
	}
	public async getCard(id: number, questionnaireId: number, clientId: number, unitId: number) {
		return await this.request.get<DashboardGetCardResponseEntity>(`/api/v1/Dashboard/Card/${id}`, { params: { QuestionnaireId: questionnaireId, ClientId: clientId, UnitId: unitId } });
	}
	public async getMap(questionnaireId: number, clientId: number, unitId: number, east: string, north: string, south: string, west: string) {
		return await this.request.get<DashboardGetMapResponseEntity>(`/api/v1/Dashboard/Map`, {
			params: { QuestionnaireId: questionnaireId, ClientId: clientId, UnitId: unitId, east: east, north: north, south: south, west: west },
		});
	}
}
